import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';

import { Logger } from '../../logging/logger';

@Injectable({ providedIn: 'root' })
export class SsrPerformanceTrackingService {
    private trackedLocations = new Set<string>();

    private logger = inject(Logger);

    // Cannot use PLATFORM token because of Circular Imports
    private isServerRendered = !!inject(DOCUMENT).getElementById('ng-state');

    /**
     * Track the time it took to hydrate this component on the page.
     *
     * @param location - The location on the page that was hydrated.
     */
    track(location: string) {
        if (!this.isServerRendered || this.trackedLocations.has(location)) {
            return;
        }
        const ttiTime = (performance.now() / 1000).toFixed(2);
        this.logger.infoRemote(`[SSR_HYDRATION_TTI_TIME]: ${location} hydrated in ${ttiTime} seconds`);
        this.trackedLocations.add(location);
    }
}
